<template>
  <DataTable
      class="p-datatable-sm"
      :value="dossiersLies"
      :resizableColumns="true"
      columnResizeMode="fit"
      sortField="destinationEntite.debutDate"
      :sortOrder="-1"
      responsiveLayout="scroll"
      :scrollableY="true"
      scrollHeight="500px"
      selectionMode="single"
      dataKey="destinationEntite.cle"
      @row-select="onDossierSelect"
  >
    <Column
        field="destinationEntite.numeroDossier"
        header="No Dossier"
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
    <Column
        field="destinationEntite.numeroCardexAfficher"
        header="No Cardex"
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
    <Column field="destinationEntite.severiteAfficher" header="Sév." :sortable="true" bodyStyle="padding: 0"
            class="table-txt-wrap">
      <template #body="slotProps">
        <div v-bind:class="obtenirCouleur(slotProps.data.destinationEntite.severite)">
          {{ slotProps.data.destinationEntite.severiteAfficher }}
        </div>
      </template>
    </Column>
    <Column
        field="destinationEntite.confidentialiteAfficher"
        header="Conf."
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
    <Column
        field="destinationEntite.natureAfficher"
        header="Nature"
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
    <Column
        field="destinationEntite.typeAfficher"
        header="Type"
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
    <Column
        field="destinationEntite.categorieAfficher"
        header="Catégorie"
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
    <Column
        field="destinationEntite.statutAfficher"
        header="Statut"
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
    <Column
        field="roleAfficher"
        header="Rôle"
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
    <Column
        field="destinationEntite.debutDate"
        header="Date de début"
        :sortable="true"
        class="table-txt-wrap"
    >
      <template #body="slotProps">
        {{
          $commun.formatDateHeure(
              slotProps.data.destinationEntite.debutDate
          )
        }}
      </template>
    </Column>
    <Column
        field="destinationEntite.finDate"
        header="Date de fin"
        :sortable="true"
        class="table-txt-wrap"
    >
      <template #body="slotProps">
        {{
          $commun.formatDateHeure(
              slotProps.data.destinationEntite.finDate
          )
        }}
      </template>
    </Column>
    <Column
        field="destinationEntite.principaleIntervenant"
        header="Intervenant"
        :sortable="true"
        class="table-txt-wrap"
    ></Column>
  </DataTable>
</template>

<script>
import axios from 'axios';
import {mapState} from "vuex";

export default {
  name: 'LiaisonsDossier',
  emits: ['dossiers'],
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch("societe/obtenirRolesLiaisonAction", {
      moduleSource: "DO",
      moduleDestination: "SU",
    }).then((res) => {
      this.listeRoles = res.data
    });
    this.getDossierLiaisons();
  },
  data() {
    return {
      genreSource: 'SU',
      dossiersLies: [],
      listeRoles: [],
    }
  },
  computed: mapState({
    jeton(state, getters) {
      return getters['cardex/jeton']
    },
    profil(state, getters){
      return getters['cardex/profil']
    }
  }),
  methods: {
    getDossierLiaisons() {
      this.$store
          .dispatch("dossier/obtenirLiaisonsGalerieAction", {
            cleSource: this.$route.params.cle,
            siteSource: this.$route.params.site,
            genreSource: this.genreSource
          })
          .then((res) => {
            this.dossiersLies = res.data.entite.liste
            this.dossiersLies.forEach((element)=> element.roleAfficher = this.roleAfficher(element.role))
            this.$emit('dossiers', this.dossiersLies)
          }).catch(() => {
        this.$toast.add({
          severity: 'error',
          summary: 'Dossier',
          detail: 'Le service dossier n\'a pas répondu dans un délai normal.',
          life: 5000
        });
      });
    },
    roleAfficher(role) {
      let roleObject = this.listeRoles[this.listeRoles.findIndex(element => element.valeur === role)];
      if(roleObject !== null && roleObject !== undefined){
          return roleObject.texte;
      }
      return "";
    },
    onDossierSelect(event) {
      this.$router.push({
        name: 'dossierConsulter',
        params: {
          cle: event.data.destinationEntite.cle,
          site: event.data.destinationEntite.site,
        },
      })
    },
    obtenirCouleur(cle) {
      return "severite" + cle;
    },
  },
}
</script>